﻿import {
	initializeMvvmContext,
	MvvmDataProvider,
	MvvmDataProviderRef,
	MvvmOptionList,
	MvvmOptionListEntry
} from "@2d-front-monorepo/design-library";
import {JSX, RefObject, useMemo} from "react";
import HolderType from "../enums/HolderType";

export type SelectHolderTypeComponentProps = {
	initialState: SelectHolderTypeModel;
	onSubmit: (formData: SelectHolderTypeModel) => Promise<void>;
	contextRef?: RefObject<MvvmDataProviderRef<SelectHolderTypeModel>>;
	children?: JSX.Element;
}

export type SelectHolderTypeModel = {
	type: HolderType;
}

export default function SelectHolderTypeComponent(props: SelectHolderTypeComponentProps): JSX.Element {
	const {
		initialState,
		onSubmit,
		contextRef,
		children
	} = props;

	const holderTypes = useMemo<MvvmOptionListEntry<HolderType>[]>(() => [
		{label: "Individual", value: HolderType.Individual},
		{label: "Business", value: HolderType.Business}
	], []);

	const context = initializeMvvmContext({
		initialState: () => {
			initialState.type = initialState.type === HolderType.Undefined ? HolderType.Individual : initialState.type;
			return initialState;
		},
		contextRef: contextRef
	});

	return <MvvmDataProvider<SelectHolderTypeModel> onSubmit={onSubmit} context={context}>
		<MvvmOptionList context={context} property="type" items={holderTypes}/>
		{children}
	</MvvmDataProvider>;
}
